export const isBakeryOpenHoursDisplayed = market => {
  const openingHours = entity =>
    JSON.stringify(entity?.map(item => [item.open_from, item.open_until]))

  return (
    openingHours(market?.openingHoursMarket) !==
      openingHours(market?.openingHoursBakery) &&
    market?.openingHoursBakery?.length > 0
  )
}
